export function WhatsAppMark({ className = "" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M19.05 4.91A9.82 9.82 0 0 0 12.06 2C6.63 2 2.2 6.42 2.2 11.86c0 1.74.46 3.44 1.33 4.94L2 22l5.36-1.4a9.83 9.83 0 0 0 4.7 1.2h.01c5.43 0 9.87-4.43 9.87-9.87 0-2.63-1.03-5.11-2.89-7.02Zm-6.99 15.22h-.01a8.17 8.17 0 0 1-4.16-1.14l-.3-.18-3.18.83.85-3.1-.2-.32a8.15 8.15 0 0 1-1.25-4.35c0-4.51 3.67-8.18 8.19-8.18 2.18 0 4.24.85 5.79 2.4a8.12 8.12 0 0 1 2.4 5.79c0 4.51-3.68 8.19-8.18 8.19Zm4.49-6.14c-.24-.12-1.43-.71-1.66-.79-.22-.08-.38-.12-.54.12s-.62.79-.76.95c-.14.17-.28.18-.52.06a6.63 6.63 0 0 1-1.95-1.2 7.28 7.28 0 0 1-1.35-1.69c-.14-.24-.01-.37.11-.49.11-.11.24-.28.36-.42.12-.14.16-.24.24-.4.08-.17.04-.31-.02-.43-.06-.12-.54-1.3-.74-1.78-.2-.48-.4-.41-.54-.42l-.46-.01c-.16 0-.43.06-.66.31-.22.24-.86.84-.86 2.05 0 1.2.88 2.37 1 2.53.12.17 1.73 2.64 4.18 3.7.58.25 1.03.4 1.39.51.58.18 1.11.16 1.53.1.47-.07 1.43-.58 1.63-1.14.2-.57.2-1.06.14-1.14-.06-.08-.22-.12-.46-.24Z" />
    </svg>
  );
}

export function FacebookMark({ className = "" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07c0 6.02 4.39 11 10.13 11.93v-8.44H7.08v-3.49h3.05V9.41c0-3.03 1.8-4.71 4.56-4.71 1.32 0 2.7.24 2.7.24v2.97h-1.52c-1.5 0-1.96.94-1.96 1.89v2.27h3.34l-.53 3.49h-2.81V24C19.61 23.07 24 18.09 24 12.07Z" />
    </svg>
  );
}

export function EbayMark({ className = "" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M3.71 8.05c-1.14 0-2.07.27-2.72.8C.35 9.38 0 10.1 0 11c0 .77.26 1.4.78 1.87.52.47 1.28.76 2.27.88l1.32.16c.64.08 1.1.22 1.37.42.27.2.4.5.4.88 0 .45-.18.8-.55 1.05-.37.25-.9.38-1.6.38-.77 0-1.34-.15-1.71-.46-.37-.31-.58-.76-.63-1.36H0c.04.96.38 1.7 1.02 2.23.64.52 1.54.79 2.7.79.98 0 1.78-.23 2.38-.7.6-.47.9-1.12.9-1.95 0-.74-.24-1.31-.73-1.73-.49-.41-1.22-.68-2.2-.82l-1.32-.17c-.66-.09-1.13-.24-1.41-.44-.28-.2-.42-.49-.42-.87 0-.41.17-.74.52-.98.34-.24.83-.36 1.46-.36.67 0 1.17.14 1.5.42.33.28.52.67.55 1.19h1.6c-.04-.91-.37-1.62-.98-2.12-.62-.5-1.46-.76-2.54-.76h-.02Zm6.82 0c-.96 0-1.74.33-2.36.98-.61.66-.92 1.5-.92 2.54v.3c0 1.04.31 1.89.92 2.54.62.66 1.4.98 2.36.98.82 0 1.5-.23 2.04-.68.54-.45.86-1.07.96-1.84h-1.6c-.08.4-.26.72-.54.95-.28.23-.63.35-1.06.35-.53 0-.96-.2-1.28-.58-.32-.38-.49-.89-.51-1.52h5.1v-.5c0-1.04-.3-1.88-.9-2.54-.6-.65-1.38-.98-2.33-.98h.16Zm3.86.14v9.44h1.64v-3.58c.52.7 1.27 1.06 2.25 1.06.95 0 1.72-.33 2.31-1 .59-.66.89-1.52.89-2.56v-.3c0-1.04-.3-1.9-.89-2.56-.59-.66-1.36-1-2.31-1-.98 0-1.73.36-2.25 1.06h-.04V8.2h-1.64Zm8.1 1.64l-2.55 5.8 1.03 2.17h1.73l3.3-7.97h-1.73l-1.65 4.4h-.04l-1.68-4.4H22.5Zm-11.8-.1c.5 0 .92.18 1.24.53.32.35.5.82.53 1.42h-3.56c.04-.6.22-1.07.54-1.42.32-.35.73-.53 1.24-.53Zm5.92.44c.56 0 1 .2 1.34.6.33.4.5.93.5 1.6v.3c0 .67-.17 1.2-.5 1.6-.34.4-.78.6-1.34.6-.56 0-1.01-.2-1.35-.6-.33-.4-.5-.93-.5-1.6v-.3c0-.67.17-1.2.5-1.6.34-.4.79-.6 1.35-.6Z" />
    </svg>
  );
}
